import type * as ImageStackTypes from '../../../../WasmModules/ImageStack';
import ImageStack from '../../../../WasmModules/ImageStack';

export interface IImageStackLoadingTask {
  readonly promise: Promise<ImageStackTypes.ImageStack>;
  interrupt: () => void;
  suspend: () => void;
  resume: () => void;
}

export function createImageStackLoadingTask(
  headerUrl: string,
  dataUrl: string,
  progress?: (processedCnt: number, totalCnt: number) => void,
  status?: (message: string) => void
): IImageStackLoadingTask {
  const imageStackBuilder = new ImageStack.ImageStackBuilder(ImageStack.DataBitness.Auto, true);

  imageStackBuilder.onHeaderLoadingProgress((): void => {});
  imageStackBuilder.onDataLoadingProgress((): void => {});

  imageStackBuilder.onDataDecodingProgress((processedCnt: number, totalCnt: number): void => {
    progress?.(processedCnt, totalCnt);
  });

  let rejectPromise: ((reason: unknown) => void) | undefined = undefined;

  return {
    promise: new Promise<ImageStackTypes.ImageStack>((resolve, reject) => {
      rejectPromise = reject;
      imageStackBuilder.loadDataAsync(
        headerUrl,
        dataUrl,
        () => {
          rejectPromise = undefined;
          const imageStack = imageStackBuilder.getImageStack();
          imageStackBuilder.dispose();
          resolve(imageStack);
        },
        (description: string) => {
          rejectPromise = undefined;
          imageStackBuilder.dispose();
          reject(new Error(description));
        },
        (description: string) => {
          status?.(description);
        }
      );
    }),
    interrupt: (): void => {
      if (rejectPromise) {
        imageStackBuilder.dispose();
        rejectPromise('Interrupted');
        rejectPromise = undefined;
      }
    },
    suspend: (): void => {
      if (rejectPromise) {
        imageStackBuilder.suspendDataLoading();
      }
    },
    resume: (): void => {
      if (rejectPromise) {
        imageStackBuilder.resumeDataLoading();
      }
    }
  };
}
